const StatusDot = ({ status, pulse = false }) => {
  const colors = {
    paid: '#2A4A35',
    pending: '#B8A96A',
    partial: '#4A4A4A',
    overdue: '#5C1A2A',
  };

  return (
    <span style={{ position: 'relative', display: 'inline-flex', width: 6, height: 6, marginRight: 8 }}>
      <span
        className={`status-dot ${pulse ? 'pulse' : ''}`}
        style={{ background: colors[status] || colors.pending, position: 'relative' }}
      />
    </span>
  );
};

export default StatusDot;
